module.exports = {"avto":5,"katalog":3}


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/seoText/countUrlParams.json
// module id = 2243
// module chunks = 1 20 22